import "./ListTable.scss";
import moment from "moment";
import findConfig from "@/lib/find-config";
export default {
  name: "ListTable",
  props: [
    "headers",
    "events",
    "totalCount",
    "getStartTime",
    "getInternInformation",
    "getInternComment",
    "getTitle",
    "filter",
    "apiKey",
    "hitsPerPage",
    "isLoading"
  ],
  data: () => ({
    settings: {},
    options: {
      itemsPerPage: 10
    }
  }),
  async mounted() {
    const data = await findConfig(this.$store.state.apiUrl, this.apiKey);
    if (data?.apiKeys?.length) this.settings = data.apiKeys[0];
    if (this.settings.hitsPerPage)
      this.options.itemsPerPage = this.settings.hitsPerPage;
  },
  methods: {
    getLocationTitle(item) {
      if (item.locationObj?.[0]?.title) return item.locationObj[0].title;
      return "";
    },
    getShortDiscountInfo(value) {
      value = value.map(item => {
        switch (item) {
          case "withFee":
            return "mE";
          case "guest_card":
            return "mGfE";
          case "discountGuestCard":
            return "RmG";
          default:
            return "";
        }
      });
      value = value.filter(val => val);
      return value.join(", ");
    },
    getDuration(item) {
      let minutes = 0;
      if (item.moment.duration && !item.moment.all_day)
        minutes = item.moment.duration;
      if (item.duration && !item.all_day) minutes = item.duration;
      else return "";
      const hours = Math.floor(minutes / 60);
      const remainingMinutes = minutes % 60;

      if (hours === 0) {
        return `${remainingMinutes} Min.`.replaceAll(" ", "&nbsp;");
      } else if (remainingMinutes === 0) {
        return `${hours} Std.`.replaceAll(" ", "&nbsp;");
      } else {
        return `${hours} Std. ${remainingMinutes} Min.`.replaceAll(
          " ",
          "&nbsp;"
        );
      }
    },
    momentCancelled(item) {
      if (item?.moment?.cancelled) return item.moment.cancelled;
      if (item?.cancelled) return item.cancelled;
    }
  },
  computed: {
    tableOptions: {
      get() {
        return this.options;
      },
      set(value) {
        value.limit = value.itemsPerPage;

        const sortDirection = value?.[0]?.sortDesc ? "desc" : "asc";

        value.sort = value?.sortBy?.[0] ?? "start";
        value.direction = sortDirection;
        this.$emit("applyFilter", {
          ...this.filter,
          ...value
        });
      }
    },
    groupedEvents() {
      const ungroupedEvents = this.events;
      ungroupedEvents.forEach(event => {
        event.groupStart = {};
        event.groupStart.formated = moment(
          event?.moment?.from ?? event?.start,
          null,
          "de"
        ).format("dddd, DD.MM.YYYY");
        event.groupStart.date =
          new Date(event?.moment?.from) ?? new Date(event?.start);
        event.groupStart.date = event.groupStart.date.setHours(0, 0, 0, 0);
      });
      return ungroupedEvents;
    }
  }
};
